import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { AttributeMappingDrawerComponent } from './attribute-mapping-drawer.component';

import { Group } from '@libs/src/models/group.model';
import { VisibleUniqueColumn } from '@main-client/src/app/attribute-mapping/attribute-mapping.helper';

@Injectable()
export class AttributeMappingDrawerService {
  constructor(private readonly drawer: NzDrawerService) {}

  openDrawer(data: {
    group: Group;
    hasSourcePathChanged: boolean;
    importedColumn: VisibleUniqueColumn;
  }) {
    return this.drawer.create({
      nzBodyStyle: { padding: 0 },
      nzClosable: true,
      nzContent: AttributeMappingDrawerComponent,
      nzData: data,
      nzMaskClosable: false,
      nzTitle: $localize`:@@attributeMappingDrawer.title:Approve field mappings`,
      nzWidth: '800px',
      nzZIndex: 998,
    });
  }
}
